export default __webpack_public_path__ + "static/media/muteCircle.ffabd5c0.svg";